import React from 'react';
import ContactContent from './ContactContent';

const deletionMessagePlaceholder = `*
あしあと帖 account deletion request

登録メールアドレス:
あしあと帖の public ID（分かる場合）:
申請内容: あしあと帖アカウントと関連データの削除リクエスト開始を申請します。
補足:
`;

function Oww2AccountDeletionContent() {
  const intro = (
    <div className="account-deletion-intro">
      <p>
        このページでは、あしあと帖のアカウントと関連データの削除を申請できます。
        アプリ内では「設定」から「アカウント削除」を選択して申請できます。
      </p>
      <p>
        Web から申請する場合は、本人確認のため、あしあと帖に登録したメールアドレスと、
        分かる場合はあしあと帖の public ID を本文に記載してください。
      </p>
      <p>
        このフォームの送信だけでは、アカウント削除は開始されません。申請内容を確認後、
        登録メールアドレスへの返信等により本人確認を行い、確認できた場合に削除リクエストを開始します。
      </p>
      <p>
        削除リクエスト開始後は、原則として30日間の削除待ち期間を設けます。
        削除待ち期間中に再ログインした場合、削除リクエストは取り消される場合があります。
      </p>
      <p>
        削除待ち期間の経過後、アカウントと関連データを削除または匿名化します。
        不正利用の防止、セキュリティ、通報対応、法令遵守、監査対応のために、
        一部のログや記録を必要な範囲で保持する場合があります。
      </p>
      <p>
        Privacy policy:{' '}
        <a href="https://oww2-legal.suikashobo.com/privacy/">
          https://oww2-legal.suikashobo.com/privacy/
        </a>
      </p>
    </div>
  );

  return (
    <ContactContent
      title="あしあと帖アカウント削除申請"
      intro={intro}
      subjectDefault="あしあと帖 account deletion request"
      messagePlaceholder={deletionMessagePlaceholder}
      successMessage="あしあと帖アカウント削除申請を受け付けました。内容確認後、必要に応じて登録メールアドレス宛に本人確認の連絡を行います。"
    />
  );
}

export default Oww2AccountDeletionContent;
